export default __webpack_public_path__ + "static/media/doc.b7032dca.jpg";